export const validateRolesAndPermissionsRequired = (values: Record<string, boolean>[], message: string): string => {
  if (Object.values(values).find((value) => !!value)) {
    return '';
  } else {
    return message;
  }
};
